// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__xnsLV","footer":"ModalInfo_footer__22qu_"};